/* ATLAS — Panier : récompenses (Black Box + livraison), code promo en direct, ensemble haut + bas. */
(function () {
  'use strict';

  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  var BOX_ATTR = 'Black Box';

  function json(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (data) { if (!r.ok) throw data; return data; });
    });
  }

  function money(cents, locale) {
    try {
      return new Intl.NumberFormat(locale || document.documentElement.lang + '-CA', { style: 'currency', currency: 'CAD' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' $';
    }
  }

  /* ---------- Récompenses ---------- */
  function renderRewards(cart) {
    document.querySelectorAll('[data-atl-rewards]').forEach(function (el) {
      var min = Number(el.dataset.min) || 2;
      var threshold = Number(el.dataset.threshold) || 0;
      var left = min - cart.item_count;
      var box = el.querySelector('[data-atl-rw-box]');
      var ship = el.querySelector('[data-atl-rw-ship]');
      if (box) {
        box.classList.toggle('is-done', left <= 0);
        box.querySelector('.atl-rw__text').textContent = left <= 0 ? el.dataset.boxDone
          : (left === 1 ? el.dataset.boxOne : el.dataset.boxOther.replace('[n]', left));
        box.querySelectorAll('.atl-rw__pips i').forEach(function (pip, i) { pip.classList.toggle('is-on', cart.item_count > i); });
      }
      if (ship && threshold) {
        var remaining = threshold - cart.total_price;
        ship.classList.toggle('is-done', remaining <= 0);
        ship.querySelector('.atl-rw__text').innerHTML = remaining <= 0 ? el.dataset.shipDone
          : el.dataset.shipLeft.replace('[amount]', money(remaining, el.dataset.locale));
        var fill = ship.querySelector('.atl-rw__fill');
        if (fill) fill.style.transform = 'scaleX(' + Math.min(cart.total_price / threshold, 1) + ')';
      }
    });
  }

  /* La commande porte la mention « Black Box : Incluse » dès que le panier atteint le minimum */
  function syncBoxAttribute(cart) {
    var holder = document.querySelector('[data-atl-rewards]');
    var min = holder ? Number(holder.dataset.min) || 2 : Number(window.atlasBlackBoxMin) || 2;
    var want = cart.item_count >= min ? 'Incluse' : '';
    var has = (cart.attributes && cart.attributes[BOX_ATTR]) || '';
    if (want === has) return;
    var attrs = {};
    attrs[BOX_ATTR] = want;
    json(cartUrl + '/update.js', { attributes: attrs }).catch(function () {});
  }

  function refreshFromCart() {
    return json(cartUrl + '.js').then(function (cart) {
      renderRewards(cart);
      syncBoxAttribute(cart);
      document.dispatchEvent(new CustomEvent('atlas:cart-changed', { detail: cart }));
      return cart;
    });
  }

  /* ---------- Page panier : nouveau rendu des sections sans recharger ---------- */
  function refreshCartPage() {
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    var bubble = document.getElementById('cart-icon-bubble');
    var ids = [items, footer].filter(Boolean).map(function (el) { return el.dataset.id; });
    if (!ids.length) return refreshFromCart();
    if (bubble) ids.push('cart-icon-bubble');
    return fetch(cartUrl + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        [items, footer].filter(Boolean).forEach(function (el) {
          var html = sections[el.dataset.id];
          if (!html) return;
          var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(el.id);
          if (fresh) el.innerHTML = fresh.innerHTML;
        });
        if (bubble && sections['cart-icon-bubble']) {
          var b = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
        bindAll(document);
        return refreshFromCart();
      });
  }

  /* ---------- Code promo ---------- */
  function bindPromo(root) {
    if (root.__atlPromo) return;
    root.__atlPromo = true;
    var form = root.querySelector('form');
    var input = root.querySelector('input[name="code"]');
    var msg = root.querySelector('.atl-promo__msg');
    var button = form.querySelector('button[type="submit"]');
    var current = (root.dataset.codes || '').split(',').filter(Boolean);

    function say(text, state) {
      msg.textContent = text;
      msg.dataset.state = state || '';
      if (state === 'ok') sessionStorage.setItem('atl-promo-msg', text);
    }

    function setCodes(list) {
      return json(cartUrl + '/update.js', { discount: list.join(',') });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = input.value.trim().toUpperCase();
      if (!code) { input.focus(); return; }
      if (current.map(function (c) { return c.toUpperCase(); }).indexOf(code) !== -1) { say(root.dataset.msgOk.replace('[code]', code), 'ok'); return; }
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      setCodes(current.concat(code))
        .then(function (cart) {
          var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code; })[0];
          if (hit && hit.applicable) {
            say(root.dataset.msgOk.replace('[code]', code), 'ok');
            return refreshCartPage();
          }
          say(root.dataset.msgBad.replace('[code]', code), 'bad');
          return setCodes(current);
        })
        .catch(function () { say(root.dataset.msgError, 'bad'); })
        .then(function () { button.disabled = false; button.removeAttribute('aria-busy'); });
    });

    root.querySelectorAll('[data-atl-promo-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.dataset.atlPromoRemove;
        btn.disabled = true;
        setCodes(current.filter(function (c) { return c !== code; }))
          .then(refreshCartPage)
          .catch(function () { btn.disabled = false; say(root.dataset.msgError, 'bad'); });
      });
    });

    /* Message gardé après le nouveau rendu de la section */
    var kept = sessionStorage.getItem('atl-promo-msg');
    if (kept) { say(kept, 'ok'); sessionStorage.removeItem('atl-promo-msg'); }
  }

  /* ---------- Ensemble haut + bas ---------- */
  function bindBundle(form) {
    if (form.__atlBundle) return;
    form.__atlBundle = true;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var button = form.querySelector('button[type="submit"]');
      if (!id) { form.querySelector('select').focus(); return; }
      button.disabled = true;
      var notification = document.querySelector('cart-notification');
      var onCart = !!document.getElementById('main-cart-items');
      var body = { id: Number(id), quantity: 1 };
      if (notification && !onCart && notification.getSectionsToRender) {
        body.sections = notification.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      json(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', body)
        .then(function (line) {
          button.textContent = button.dataset.added;
          if (onCart) return refreshCartPage();
          if (notification && line.sections) notification.renderContents(line);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'atlas-bundle', productVariantId: id });
          } else {
            refreshFromCart();
          }
        })
        .catch(function (err) {
          button.disabled = false;
          if (err && err.description) window.alert(err.description);
        });
    });
  }

  function bindAll(scope) {
    scope.querySelectorAll('[data-atl-promo]').forEach(bindPromo);
    scope.querySelectorAll('[data-atl-bundle-form]').forEach(bindBundle);
  }

  function boot() {
    bindAll(document);
    if (document.querySelector('[data-atl-rewards]')) refreshFromCart().catch(function () {});
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refreshFromCart().catch(function () {}); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { bindAll(e.target); });
})();
